import { PetFilter } from "../PetFilter";
import React from "react";

export const PetFilters = () => {
  return (
    <div className="pet-filters">
      <PetFilter petType="cat" />
      <PetFilter petType="dog" />
    </div>
  );
};
